var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVesselLiveTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5021_2515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.22794 18.2272L2.59222 14.3958C2.35786 13.8469 2.65345 13.2162 3.22528 13.0451L10.2219 10.9518C10.4089 10.8959 10.6082 10.8959 10.7952 10.9518L17.7918 13.0451C18.3636 13.2162 18.6592 13.8469 18.4248 14.3958L16.7891 18.2272H4.22794Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.63745 6.86142V9.86097L10.5359 8.21948L16.3794 9.86097V6.86142C16.3794 6.30913 15.9317 5.86142 15.3794 5.86142H5.63745C5.08517 5.86142 4.63745 6.30914 4.63745 6.86142Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.42 2.68775V3.3536H8.59705V2.68775C8.59705 1.63206 9.45285 0.77626 10.5085 0.77626C11.5642 0.77626 12.42 1.63206 12.42 2.68775Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7891 18.2272C17.7449 18.0883 18.2033 18.7625 19.1102 19.0605C19.4104 19.1591 19.1665 19.0752 19.5632 19.2273",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.19952 18.2272C3.24377 18.0883 2.78536 18.7625 1.87842 19.0605C1.57821 19.1591 1.82214 19.0752 1.42544 19.2273",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5021_2515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.661,
    height: 20,
    fill: "white",
    transform: "translate(0.677979)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVesselLiveTracking);
export default __webpack_public_path__ + "static/media/vessel-live-tracking.b95a3925039d604c8dd7dfa1a1cfe796.svg";
export { ForwardRef as ReactComponent };